<template>
<!-- 企业管理-创建企业-查看合同 -->

    <el-dialog :visible.sync="show" :close-on-click-modal="false" append-to-body width="50%" :before-close="closeDialog">
        <div v-if="images.length == 0" style="text-align: center; font-size: 25px; margin-bottom: 20px">暂无合同图片</div>
        <div v-else style="display: flex">
            <el-image
                v-for="(item, index) in images"
                :key="index"
                :preview-src-list="srcList"
                style="width: 200px; height: 200px; margin-bottom: 20px; margin-right: 20px"
                :src="item"
            ></el-image>
        </div>
        <!-- 对话框底部按钮 -->
        <div style="display: flex; justify-content: center">
            <el-button @click="closeDialog">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
let _this;
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.images = [];
            _this.srcList = [];

            if (_this.data.contract_hash_1_url != '') {
                _this.images.push(_this.data.contract_hash_1_url);
                _this.srcList.push(_this.data.contract_hash_1_url);
            }
            if (_this.data.contract_hash_2_url != '') {
                _this.images.push(_this.data.contract_hash_2_url);
                _this.srcList.push(_this.data.contract_hash_2_url);
            }

            if (_this.data.contract_hash_3_url != '') {
                _this.images.push(_this.data.contract_hash_3_url);
                _this.srcList.push(_this.data.contract_hash_3_url);
            }

            if (_this.data.contract_hash_4_url != '') {
                _this.images.push(_this.data.contract_hash_4_url);
                _this.srcList.push(_this.data.contract_hash_4_url);
            }
        }
    },
    created() {
        _this = this;
    },
    data() {
        return {
            show: false,
            srcList: [],
            images: []
        };
    },
    methods: {
        // 关闭方法
        closeDialog() {
            _this.show = false;
        }
    }
};
</script>

<style scoped>
.pagination {
    text-align: right;
}
</style>
